import step2Schema from './step-2.blurb.schema'

import step3Schema from './step-3.token.schema'

import FundTypeStep from '../steps/Step.FundType'
import GeneralInfoStep from '../steps/Step.GeneralInfo'
import StepTokenCreation from '../steps/Step.TokenCreation'
import DefaultStep from '../steps/Step.Default'
import PublicationStep from '../steps/Step.Publication'
import { i18n } from '@js/i18n'

export default [
  { name: 'step-1', done: false, component: FundTypeStep, label: i18n.sale_type_fund() },
  { name: 'step-2', done: false, component: GeneralInfoStep, label: i18n.sale_campaign_settings() },
  { name: 'step-3', done: false, component: StepTokenCreation, schema: step3Schema, label: i18n.sale_create_token() },
  { name: 'step-4', done: false, component: DefaultStep, schema: step2Schema, label: i18n.sale_description_step() },
  { name: 'step-5', done: false, component: PublicationStep, label: i18n.sale_publication() }
]



// WEBPACK FOOTER //
// ./src/vue/app/saleCreation/specs/steps.schema.js